class GalleryFilterList extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.onClick.bind(this));
  }

  onClick(event) {
    const button = event.target.closest('.gallery-grid__filter-btn');
    if (!button) return;

    const filter = button.dataset.filter;
    const list = this.closest('.gallery-grid').querySelector('.gallery-grid__list');
    const items = list.querySelectorAll('.gallery-grid__item');

    this.querySelectorAll('.gallery-grid__filter-btn').forEach((btn) => {
      btn.classList.toggle('is-active', btn === button);
      btn.setAttribute('aria-pressed', btn === button ? 'true' : 'false');
    });

    items.forEach((item) => {
      const categories = (item.dataset.categories || '').split(' ').filter(Boolean);
      const show = filter === 'all' || categories.includes(filter);
      item.classList.toggle('is-filtered-out', !show);
    });
  }
}

customElements.define('gallery-filter-list', GalleryFilterList);
